import { reactive } from "vue";

export const loadingStore = reactive({
  isLoading: false,
});

export function startLoading() {
  loadingStore.isLoading = true;
}

export function stopLoading() {
  loadingStore.isLoading = false;
}